// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__1Thuq","form":"styles_form__-r_I2"};